import { render, staticRenderFns } from "./AlternateAction.vue?vue&type=template&id=6b460418&"
import script from "./AlternateAction.vue?vue&type=script&lang=js&"
export * from "./AlternateAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports